import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { LiveMapResponse } from './live-map.types'

/** Intervalle de polling pour la supervision (MVP : pas de WS admin). */
export const LIVE_MAP_POLL_MS = 5_000

/**
 * Récupère l'état temps réel de la carte (chauffeurs online + courses actives).
 * `refetchInterval` 5s + retry TanStack Query (bandeau "Données indisponibles"
 * géré côté page sur `isError`). `placeholderData` (garde l'ancienne donnée)
 * évite le clignotement de la carte entre deux polls.
 */
export function useLiveMap() {
  return useQuery<LiveMapResponse>({
    queryKey: ['admin', 'live-map'],
    queryFn: async () => {
      const { data } = await api.get<LiveMapResponse>('/admin/live-map')
      return data
    },
    refetchInterval: LIVE_MAP_POLL_MS,
    placeholderData: (prev) => prev,
    staleTime: 0,
  })
}
